import { useSetAtom } from 'jotai';
import { Button } from '@antimatterhq/ui/components/button';
import { QueryRecentsList } from './QueryRecentsList';
import { createNewQueryTabAtom } from '@/atoms/query/queryAtoms';

export function QueryEmptyState() {
  const createTab = useSetAtom(createNewQueryTabAtom);

  return (
    <div className="flex h-full" data-testid="query-empty-state">
      <div className="w-full p-8">
        <h2 className="mb-4 text-base font-medium text-black dark:text-white">
          Create new
        </h2>
        <div className="mb-8">
          <Button
            onClick={() => createTab()}
            variant="default"
            className="h-auto justify-start px-3 py-2 text-sm font-normal"
            data-testid="create-sql-query-button"
            leftIcon="lucide:database"
          >
            <b>SQL Query</b>
          </Button>
        </div>
        <div>
          <h2 className="mb-4 text-base font-medium text-black dark:text-white">
            Quick access
          </h2>
          <div className="mb-6 flex items-center gap-2">
            <Button
              variant="primary"
              size="small"
              className="h-7 rounded-full px-3 text-xs"
              data-testid="recents-tab-button"
              leftIcon="lucide:calendar"
            >
              Recents
            </Button>
            <Button
              variant="default"
              size="small"
              className="h-7 rounded-full px-3 text-xs"
              data-testid="favorites-tab-button"
              leftIcon="lucide:plus"
            >
              Favorites
            </Button>
          </div>
          <QueryRecentsList />
        </div>
      </div>
    </div>
  );
}
